import { Divider, HStack, Link, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import trainerRoutes from "../../pages/trainer/routes";
import courseRoutes from "../../pages/courses/courseRoutes";
import routes from "../../pages/routes";

const TraineeMobileNav = ({ courseId }: { courseId: string }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuLinks = [
    {
      text: "Course Information",
      route: courseRoutes.CourseInformationLink(courseId),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: courseRoutes.AnnouncementLink(courseId),
      keywords: ["announcement"],
    },
    {
      text: "Event Scheduler",
      route: courseRoutes.CalenderLink(courseId),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: courseRoutes.DiscussionsLink(courseId),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: courseRoutes.AssignmentsLink(courseId),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Resources",
      route: courseRoutes.ResourcesLink(courseId),
      keywords: ["resource", "resources"],
    },
    {
      text: "Survey",
      route: routes.SurveyEntryLink(courseId),
      keywords: ["survey"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };
  return (
    <>
      {" "}
      <HStack
        overflowX="scroll"
        width={"100%"}
        height={"60px"}
        justifyContent={"space-around"}
        alignItems={"center"}
        fontSize={"13px"}
        padding={"0px 8px"}
        bg="white"
        className="scroll-hidden"
        // mt="1.38rem"
        flex={"no-wrap"}
      >
        {menuLinks.map((link, index) => (
          <React.Fragment key={index}>
            <Link
              onClick={() => navigate(link.route)}
              textAlign={"center"}
              alignContent={"center"}
              wordBreak={"keep-all"}
              height={"60px"}
              borderBottom={activeLink(link.route, link.keywords).borderLeft}
              borderColor={activeLink(link.route, link.keywords).borderColor}
              color={activeLink(link.route, link.keywords).textColor}
            >
              {link.text}
            </Link>
            {index < menuLinks.length - 1 && (
              <Divider orientation="vertical" height="70%" />
            )}
          </React.Fragment>
        ))}
      </HStack>
    </>
  );
};

export default TraineeMobileNav;
